import React from 'react';
import Checkbox from 'lib/Checkbox';
import { SearchResultsSectionProps } from './FrameListPanel.types';

export const SearchResultsSection: React.FC<SearchResultsSectionProps> = ({
  fetchedOptions,
  searchText,
  isFrameSelected,
  handleFrameToggle,
}) => {
  if (fetchedOptions.length) {
    return (
      <div className="py-2">
        {fetchedOptions.map((frame) => (
          <div key={`${frame.code}-${frame.mediaOwner}`} className="px-4 py-2 hover:bg-neutral-50">
            <Checkbox
              value={frame.code}
              label={frame.code}
              isSelected={isFrameSelected(frame.code, frame.mediaOwner)}
              onChange={() => handleFrameToggle(frame, !isFrameSelected(frame.code, frame.mediaOwner))}
            />
          </div>
        ))}
      </div>
    );
  }

  if (searchText?.length >= 2) {
    return <p className="text-center px-5 py-2.5 sub-header-base">No results found</p>;
  }

  return null;
};
